var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 144.773 144.773",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8DC5D6"
    },
    cx: 72.387,
    cy: 72.386,
    r: 72.386
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 72.387,
    cy: 72.386,
    r: 72.386
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E576D"
    },
    d: "M45.234,75.056c0,11.808-6.479,12.113-6.018,19.932c0.513,8.659,7.281,8.679,7.281,14.632 c0,5.951-6.224,12.624-0.71,19.033c24.244,0,26.61,0,26.61,0V56.445L45.234,75.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E576D"
    },
    d: "M99.538,74.665c0,11.808,6.48,12.113,6.018,19.932c-0.512,8.659-7.28,8.679-7.28,14.632 c0,5.951,6.223,12.624,0.71,19.033c-24.245,0-26.611,0-26.611,0V56.055L99.538,74.665z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2E576D"
    },
    cx: 72.387,
    cy: 62.721,
    rx: 29.635,
    ry: 29.828
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M107.053,116.94c-4.666-8.833-34.666-14.376-34.666-14.376s-30,5.543-34.666,14.376 c-3.449,12.258-6.334,27.833-6.334,27.833h41h41C113.387,144.773,111.438,128.073,107.053,116.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.387,102.564c0,0,30,5.543,34.666,14.376c4.386,11.133,6.334,27.833,6.334,27.833h-41V102.564 z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.22,
    y: 84.606,
    style: {
      fill: "#F1C9A5"
    },
    width: 16.334,
    height: 27.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.387,
    y: 84.606,
    style: {
      fill: "#E4B692"
    },
    width: 8.167,
    height: 27.336
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#DDAC8C"
    },
    d: "M64.22,97.273c1.469,4.217,7.397,6.634,11.751,6.634 c1.575,0,3.108-0.264,4.583-0.747V84.606H64.22V97.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M93.387,67.357c0-17.074-9.402-26.783-21-26.783c-11.598,0-21,9.709-21,26.783 c0,17.074,9.402,30.917,21,30.917C83.984,98.274,93.387,84.432,93.387,67.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M90.19,79.195c-3.807-0.424-6.377-4.783-5.732-9.732c0.637-4.953,4.242-8.63,8.051-8.209 c3.805,0.422,6.371,4.779,5.729,9.732C97.599,75.939,93.997,79.613,90.19,79.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M46.685,70.986c-0.643-4.953,1.924-9.311,5.727-9.732c3.81-0.421,7.416,3.256,8.055,8.209 c0.642,4.949-1.93,9.309-5.734,9.732C50.925,79.613,47.323,75.939,46.685,70.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M93.387,67.357c0-17.074-9.402-26.783-21-26.783v57.7C83.984,98.274,93.387,84.432,93.387,67.357 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E576D"
    },
    d: "M95.12,65.43c0-0.051,0.003-0.1,0.003-0.15c0-13.245-8.967-27.222-21.518-27.222 S49.674,52.034,49.674,65.279c0,0.051,0.003,0.1,0.003,0.15H95.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FA582A"
    },
    d: "M113.387,144.773c0,0-1.948-16.7-6.334-27.833c-2.559-4.845-12.734-8.696-21.406-11.189 l-13.291,10.432l-13.825-10.26c-8.535,2.497-18.31,6.284-20.81,11.018c-3.449,12.258-6.334,27.833-6.334,27.833h41H113.387z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.ea4bf2c5b832a9dfa8c1b96957815fc4.svg";
export { ForwardRef as ReactComponent };